module.exports = {
    "id": "water",
    "title": "water",
    "image": "provision/parts/water/water.png",
    "info": [
      {
        "text": "Add water to your project",
        "image": "provision/parts/water/water.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/water/water.png"
  } ;